import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, Hammer, Sparkles } from 'lucide-react';
import logo from '../assets/logo.png';

/**
 * "Página en construcción" landing shown to the public while the site is in
 * demo/maintenance mode. Members and staff log in from here.
 */
export default function ConstructionPage() {
  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-charcoal-900" data-testid="construction-page">
      {/* Background layers */}
      <div
        className="absolute inset-0"
        style={{ background: 'radial-gradient(circle at 30% 20%, #006199 0%, #00355C 45%, #021726 100%)' }}
      />
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-cmic-500/20 blur-3xl" />
      <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-amber-400/10 blur-3xl" />

      <div className="relative z-10 max-w-xl w-full mx-auto px-6 text-center">
        <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/40 p-10 sm:p-12">
          <img src={logo} alt="CMIC" className="h-20 w-auto mx-auto mb-6" />

          <span className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 text-xs font-semibold tracking-wide uppercase px-3 py-1.5 rounded-full mb-5">
            <Hammer size={13} /> Sitio en construcción
          </span>

          <h1 className="text-3xl sm:text-4xl font-bold text-charcoal-900 tracking-tight mb-3 leading-tight">
            Estamos preparando algo<br />
            <span style={{ color: 'var(--cmic-primary, #006199)' }}>extraordinario</span>
          </h1>

          <p className="text-charcoal-600 text-base leading-relaxed mb-2">
            El nuevo portal del <strong>Colegio Mexicano de Intérpretes de Conferencias</strong> estará disponible muy pronto.
          </p>
          <p className="text-charcoal-500 text-sm mb-8 flex items-center justify-center gap-1.5">
            <Sparkles size={14} className="text-amber-500" /> Gracias por tu paciencia y por ser parte de esta comunidad.
          </p>

          <Link
            to="/login"
            data-testid="construction-member-access"
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-white shadow-lg rounded-xl px-8 py-3.5 font-bold transition-all transform hover:-translate-y-0.5 hover:shadow-xl"
            style={{ backgroundColor: 'var(--cmic-primary, #006199)' }}
          >
            <LogIn size={18} /> Acceso a miembros
          </Link>

          <p className="text-charcoal-400 text-xs mt-6">
            Si eres miembro, inicia sesión para revisar y validar la información de tu perfil.
          </p>
        </div>
      </div>
    </div>
  );
}
